import LangEnum from '../../../lang/LangEnum';
import { TeceoApiResponse } from '../../../lib/basicRepository';

export enum LoadingStatus {
  LOADING = 'LOADING',
  SAVED = 'SAVED',
  ERROR = 'ERROR',
}

export interface IErrorData<T = any> {
  code?: LangEnum;
  message?: string;
  data: T;
}

export interface HandleLoadingStatusProps<T, ErrorData> {
  requestFn: () => Promise<T>;
  onSuccess?: () => void;
  onFailure?: (err: IErrorData<ErrorData>) => void;
}

export interface LoadingStatusStoreProps {
  loadingStatus: LoadingStatus;
  pendingRequests: number;
  /**
   *
   * @deprecated do not use this setter, use handleLoadingStatus instead
   */
  setLoadingStatus: (newStatus: LoadingStatus) => void;
  handleLoadingStatus<T, ErrorData = any>({
    requestFn,
  }: HandleLoadingStatusProps<T, ErrorData>): Promise<T>;
  trackRequestStatus<T>(
    requestFn: () => Promise<TeceoApiResponse<T>>,
  ): Promise<TeceoApiResponse<T>>;
}
